import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "submitButton"]

  connect() {
    this.initializeFormTracking()
  }

  disconnect() {
    if (this.formFields) {
      this.formFields.forEach(field => {
        field.removeEventListener("input", this.handleFieldChangeHandler)
      })
    }
  }

  initializeFormTracking() {
    this.formFields = [
      ...this.formTarget.querySelectorAll("input"),
      ...this.formTarget.querySelectorAll("select")
    ].filter(field => !field.classList.contains("toggle-submit-button-ignore"))
    this.initialState = this.captureCurrentFormState()
    this.updateSubmitButtonState()

    // Store bound handler for cleanup
    this.handleFieldChangeHandler = () => this.handleFieldChange()

    this.formFields.forEach(field => {
      field.addEventListener("input", this.handleFieldChangeHandler)
    })
  }

  captureCurrentFormState() {
    const state = new Map()
    this.formFields.forEach(field => {
      state.set(field, this.getFieldValue(field))
    })

    return state
  }

  hasFormChanged() {
    if (!this.initialState) {
      return false
    }

    for (const field of this.formFields) {
      if (this.initialState.get(field) !== this.getFieldValue(field)) {
        return true
      }
    }
    return false
  }

  handleFieldChange() {
    this.updateSubmitButtonState()
  }

  updateSubmitButtonState() {
    const hasChanges = this.hasFormChanged()
    this.submitButtonTarget.disabled = !hasChanges
    this.submitButtonTarget.classList.toggle("button--disabled", !hasChanges)
  }

  getFieldValue(field) {
    return field.type === "checkbox" || field.type === "radio" ? field.checked : field.value
  }
}
